import { Menu } from 'lucide-react';
import type { ReactNode } from 'react';

import { useAppShell } from './AppShell';

interface TopBarProps {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
}

export function TopBar({ title, subtitle, actions }: TopBarProps) {
  const { toggleSidebar } = useAppShell();

  return (
    <header
      className="flex items-center justify-between border-b border-slate-200 bg-white px-4 md:px-6 shrink-0"
      style={{ height: 'var(--topbar-height)' }}
    >
      <div className="flex items-center gap-3">
        <button
          onClick={toggleSidebar}
          className="rounded-md p-1.5 text-slate-500 hover:bg-slate-100 md:hidden"
          aria-label="Ouvrir le menu"
        >
          <Menu size={20} />
        </button>
        <div>
          <h1 className="text-lg font-semibold text-slate-900">{title}</h1>
          {subtitle && <p className="text-sm text-slate-500">{subtitle}</p>}
        </div>
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </header>
  );
}
